<span class="ag-overlay-loading-center">
  <h4 class="text-tertiary">{{ params.content | translate }}</h4>
</span>
